import { Form } from 'formik';
import { dialogForm } from 'omakase/Dialog/dialogCoreCssDefs';
import React from 'react';

const DialogForm: React.FunctionComponent = (props) => <Form css={dialogForm} {...props} />;
export default DialogForm;
